<template>
  <div>
    <CardText 
      title="Privacy policy" 
      subTitle="for Barhopp Android & iOS App" 
      type="privacy"
       />
  </div>
</template>

<script>
import CardText from "./CardText";
export default {
  components: {
    CardText,
  },
  data() {
    return {};
  },
};
</script> 

<style scoped>
</style>